import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import {
  getAlgoRefreshFlat,
  getFilter,
} from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';
import { sortTimestamps } from '../../../../../helpers/special-sort/sortTimestamps';

function useOptions() {
  const options = [
    {
      label: 'No start time',
      value: undefined,
    },
  ];
  const data = useSelector(getAlgoRefreshFlat);

  let timestamps = [];

  data.forEach((item) => {
    if (
      item.startTime &&
      !timestamps.some((option) => option === item.startTime)
    ) {
      timestamps.push(item.startTime);
    }
  });

  const sortedTimestamps = sortTimestamps(timestamps);

  sortedTimestamps.forEach((item) => {
    options.push({
      value: item,
      label: item,
    });
  });

  return options;
}

const ViewStartTime = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.startTime ? true : false;
  const options = useOptions();

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="startTime"
          title="Filter Start Time:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewStartTime;
